<div class="modal-header">
  <h4 class="modal-title pull-left">
    {{ 'admintool.duplicate_order_numbers.title' | translate }}
  </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <p class="pre-wrap break-word">{{ 'admintool.duplicate_order_numbers.save.message' | translate }}</p>
  </div>
</div>
<div class="modal-footer">
  <button type="button"
          class="btn btn-secondary btn-cancel"
          (click)="cancel()">
    {{'global.label.cancel' | translate}}
  </button>
  <button type="button"
          class="btn btn-primary"
          (click)="save()">
    {{'admintool.duplicate_order_numbers.button.continueSave' | translate}}
  </button>
</div>
